import { UserDTO as UserInfo } from '@chicilon/angular-user-service';
import { createReducer, on } from '@ngrx/store';
import {
  login,
  loginFailed,
  loginSuccess,
  logout,
  register,
  registerFailed,
  registerSuccess,
  updateUserInfoField
} from './auth.actions';

export interface AuthState {
  accessToken?: string;
  refreshToken?: string;
  expiredToken?: string;
  error: string;
  isLogging: boolean;
  isRegistering: boolean;
  isLoggedIn: boolean;
  otpRequired: boolean;
  user?: UserInfo;
}

const initialState: AuthState = {
  accessToken: undefined,
  refreshToken: undefined,
  expiredToken: undefined,
  error: '',
  user: undefined,
  isLogging: false,
  isRegistering: false,
  isLoggedIn: false,
  otpRequired: false
};

export const authReducer = createReducer(
  initialState,
  on(login, state => ({
    ...state,
    error: '',
    isLogging: true
  })),

  on(loginSuccess, (state, { accessToken, refreshToken, expiredToken, user }) => ({
    ...state,
    accessToken,
    refreshToken,
    expiredToken,
    user,
    isLogging: false,
    isLoggedIn: true
  })),

  on(loginFailed, (state, { error }) => ({
    ...state,
    error,
    isLogging: false
  })),

  // on(otpRequired, state => ({
  //   ...state,
  //   otpRequired: true
  // })),

  // on(verifyOtp, state => ({
  //   ...state,
  //   error: '',
  //   isLogging: true
  // })),

  // on(verifyOtpSuccess, (state, { accessToken, user }) => ({
  //   ...state,
  //   accessToken,

  //   user,
  //   isLogging: false,
  //   isLoggedIn: true
  // })),

  // on(verifyOtpFailed, (state, { error }) => ({
  //   ...state,
  //   error,
  //   isLogging: false
  // })),

  on(register, state => ({
    ...state,
    isRegistering: true
  })),

  on(registerSuccess, state => ({
    ...state,
    isRegistering: false
  })),

  on(registerFailed, (state, { error }) => ({
    ...state,
    error,
    isRegistering: false
  })),

  on(logout, state => ({
    ...state,
    isLoggedIn: false,
    user: undefined
  })),

  on(updateUserInfoField, (state, { user }) => ({
    ...state,
    user: user
  }))
);
